import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/wechat-qrcode.jpg';
const _withScopeId = n => (_pushScopeId("data-v-3abca904"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tooltip-box"
};
const _hoisted_2 = {
  class: "flex-align-center",
  title: "参与有奖问卷 领9折优惠券"
};
const _hoisted_3 = {
  class: "hide-box-layout"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "参与有奖问卷 领9折优惠券", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "问卷", -1));
const _hoisted_9 = {
  class: "flex-align-center"
};
const _hoisted_10 = {
  class: "tooltip-item"
};
const _hoisted_11 = {
  class: "hide-box-layout"
};
const _hoisted_12 = {
  class: "hide-box qrcode-box kefu"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "客服热线：", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "186 7488 0274", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信扫一扫 联系我们", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信", -1));
const _hoisted_18 = {
  class: "flex-align-center"
};
const _hoisted_19 = {
  class: "tooltip-item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hide-box-layout"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "hide-box collect-box"
}, [/*#__PURE__*/_createElementVNode("h1", null, "收藏网站"), /*#__PURE__*/_createElementVNode("div", {
  class: "flex-align-between"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, "Windows 用户"), /*#__PURE__*/_createElementVNode("h2", null, "Ctrl+D")]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, "Mac 用户"), /*#__PURE__*/_createElementVNode("h2", null, "Command+D")])])])], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收藏", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Document = _resolveComponent("Document");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_ChatDotRound = _resolveComponent("ChatDotRound");
  const _component_StarFilled = _resolveComponent("StarFilled");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
    class: "hide-box collect-box",
    href: $data.QQ_WJ_LINK,
    target: "_blank"
  }, _hoisted_6, 8, _hoisted_4)]), _createElementVNode("a", {
    class: "tooltip-item",
    href: $data.QQ_WJ_LINK,
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Document)]),
    _: 1
  }), _hoisted_8], 8, _hoisted_7)]), _createElementVNode("li", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _hoisted_14, _createVNode(_component_el_divider), _hoisted_15, _hoisted_16])]), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ChatDotRound)]),
    _: 1
  }), _hoisted_17])]), _createElementVNode("li", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_StarFilled)]),
    _: 1
  }), _hoisted_21])])])]);
}